// extracted by mini-css-extract-plugin
export default {"root":"uzIkrRHjD4XikHkuXhW_"};